import type { SilobagListItem } from '@siloreal:shared:api/service/silobag/silobag-list';

export async function downloadSilobagReport(
  rows: readonly SilobagListItem[],
  fileName: string
): Promise<number> {
  if (rows.length === 0) {
    throw new Error('No hay silobolsas para exportar.');
  }

  const { generateSilobagExcelData } = await import('@siloreal:shared:sdk/excel/silobag-excel-generator');

  await generateSilobagExcelData(rows, fileName);

  return rows.length;
}
